import { render, staticRenderFns } from "./ArtikelHome.vue?vue&type=template&id=4fac15fb&"
import script from "./ArtikelHome.vue?vue&type=script&lang=js&"
export * from "./ArtikelHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports